import { render, staticRenderFns } from "./BlockType15.vue?vue&type=template&id=817cad9a&scoped=true&"
import script from "./BlockType15.vue?vue&type=script&lang=ts&"
export * from "./BlockType15.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType15.vue?vue&type=style&index=0&id=817cad9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817cad9a",
  null
  
)

export default component.exports